// extracted by mini-css-extract-plugin
module.exports = {"successIcon":"FormComponent_successIcon__QEaj4"};